import React from 'react';

export default class ZooNothingFoundPage extends React.Component {
	render() {
		return (
			<div className="ZooNothingFoundPage CENTERED">
				<img alt="Not found" src="/images/404.jpg" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ZooNothingFoundPage.js